import type { VisionLocationMetadata } from '../interfaces/visionLocationMetadata.interface'

export const collectVisionLocationMetadata = (): VisionLocationMetadata | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const { origin, hostname, protocol, port, pathname, search } = window.location

  return {
    origin,
    hostname,
    protocol,
    port,
    pathname,
    href: `${origin}${pathname}${search}`,
  }
}
